module.exports = __webpack_public_path__ + "img/icon-search.6e99b901.svg";